var exports = {
  "J": "xcc377c0b--ec13cb--actual",
  "P": "xcc377c0b--ec13cb--label",
};

module.exports = exports;
